import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { C_JOB_PATTERN_CATEGORIES } from 'shared-lib'

@Component({
  selector: 'c-job-pattern',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
  template: `
    <div
      class="e11-text-white e11-rounded-lg e11-text-sm"
      [ngClass]="{
        'e11-px-6 e11-py-2': size == 'md',
        'e11-px-4 e11-py-1.5': size == 'sm'
      }"
      [style.background-color]="candidatePattern?.color"
      [style.color]="candidatePattern?.textColor"
    >
      {{ candidatePattern?.pattern }}
    </div>
  `,
})
export class CJobPatternComponent {
  _cJobPattern?: string = ''
  @Input() set cJobPattern(value: string | undefined) {
    if (value) {
      this._cJobPattern = value
      this.candidatePattern = C_JOB_PATTERN_CATEGORIES.find(p => p.pattern == this._cJobPattern)
    }
  }
  @Input() size: 'md' | 'sm' = 'md'

  candidatePattern = C_JOB_PATTERN_CATEGORIES.find(p => p.pattern == this._cJobPattern)
}
